import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { MarketplaceCatalogItem } from '../models/marketplace-catalog-item.model';
import { PaginatedResult } from '../models/paginated-result.model';
import { ApiType, ServiceBase } from '../shared/classes/serviceBase';
import { environment } from '../../environments/environment';

/**
 * The live marketplace catalog — Retail.API api/admin/marketplace-catalog
 * (platform admin). Every marketplace-space item including inactive ones;
 * deleted items are never listed.
 */
@Injectable({ providedIn: 'root' })
export class MarketplaceCatalogService extends ServiceBase {
  private readonly endpoint = 'api/admin/marketplace-catalog';

  constructor(http: HttpClient, router: Router) {
    super(http, router);
  }

  protected override getBusinessIdValue(): string {
    return environment.marketplaceBusinessId;
  }

  protected override getTerminalIdValue(): string {
    return environment.marketplaceTerminalId;
  }

  getProducts(
    pageNumber: number,
    pageSize: number,
    searchQuery?: string,
    businessId?: string,
    activeOnly = false
  ): Observable<PaginatedResult<MarketplaceCatalogItem>> {
    let params = new HttpParams()
      .set('pageNumber', pageNumber)
      .set('pageSize', pageSize)
      .set('activeOnly', activeOnly);
    if (searchQuery?.trim()) {
      params = params.set('searchQuery', searchQuery.trim());
    }
    if (businessId?.trim()) {
      params = params.set('businessId', businessId.trim());
    }
    return this.get<PaginatedResult<MarketplaceCatalogItem>>(`${this.endpoint}/GetProducts`, ApiType.RETAIL, params);
  }
}
